/* DM TELCO — native header menu behaviour.
   Desktop: hover opens/closes the rail dropdowns (Dawn's details/summary
   is click-only by default). Gated to viewports with a real hover pointer,
   so touch devices keep tap-to-open and keyboard use is untouched
   (toggling the open attribute fires the toggle event Dawn's HeaderMenu
   listens to for its bottom-border positioning). */
(function () {
  var hoverMedia = window.matchMedia('(min-width: 990px) and (hover: hover)');
  var CLOSE_DELAY_MS = 150; // grace period so crossing the gap between summary and panel doesn't flicker

  function init() {
    document
      .querySelectorAll('.header__inline-menu header-menu > details')
      .forEach(function (details) {
        var summary = details.querySelector('summary');
        var closeTimer = null;

        details.addEventListener('mouseenter', function () {
          if (!hoverMedia.matches) return;
          clearTimeout(closeTimer);
          if (!details.hasAttribute('open')) {
            details.setAttribute('open', '');
            if (summary) summary.setAttribute('aria-expanded', 'true');
          }
        });

        details.addEventListener('mouseleave', function () {
          if (!hoverMedia.matches) return;
          clearTimeout(closeTimer);
          closeTimer = setTimeout(function () {
            details.removeAttribute('open');
            if (summary) summary.setAttribute('aria-expanded', 'false');
          }, CLOSE_DELAY_MS);
        });
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
